<app-service-detail>
    <div class="row w-100 m-0 position-relative">
        <app-variables-tabs
            primarySelectedTab="Tables" class="container-fluid px-5">
        </app-variables-tabs>
        <app-list-grid *ngIf="!hideList"
                       class="col-md-12 px-md-5 ml-auto"
                       [items]="determinants"
                       [determinantMapById]="determinantMapById"
                       [baseUrl]="baseUrl"
                       [hash]="hash"
                       [toggleIcons]="false"
                       [badgeIcons]="true"
                       [navigationEdit]="false"
                       [expanded]="true"
                       [multipleSelect]="true"
                       [selectAll]=true
                       [hasFieldNumber]="true"
                       [counterSortKey]="'fieldNumber'"
                       [showDuplicateIndicator]="true"
                       (editFunction)="loadDeterminant($event)"
                       (deleteFunction)="deleteDeterminant($event)"
                       (updateFunction)="saveDeterminant($event)"
                       (filterBy)="onNewFilterBy($event)"
                       headingText="Determinants available in the service"
                       [elementsNumber]="elementsNumber"
                       createNewText1Part="Select an existing role or click on"
                       [showItemStatus]="true"
                       createNewText2Part="to create a new role">
            <button (click)="loadDeterminant(false)"
               placement="left"
               aria-hidden="true"
               class="btn btn-sm btn-primary mr-1">{{ 'Add' | translate }}</button>
        </app-list-grid>

        <determinant-new  *ngIf="showEdit || showAdd" [serviceId]="serviceId"
            [determinant]="determinant"
            [existingDeterminants]="determinants"
            [isClosed]="false"
            [noContentPadding]="true"
            (formSubmit)="closeSlider()"
            (editCancel)="closeLayers()"></determinant-new>
        
        <div class="shadow"></div>
        <div class="col">
            <tab-menu *ngIf="hideList"
                      [items]="determinants"
                      [baseUrl]="baseUrl"></tab-menu>
            <ng-content></ng-content>
        </div>
    </div>
</app-service-detail>
